export type ThoughtSpotLoginResponse = {
    token: string
}

export class Liveboard {
    id!: string;
    name!: string;
    icon!: string;
}

export class LiveboardMenuItems {
    admin!: Liveboard[];
    user!: Liveboard[];
    shared!: Liveboard[];
}

export class Answer {
    id!: string;
    name!: string;
}
